import { isMobile } from "Utils/Dimension";
import {
  primaryColor
} from "../material-kit-pro-react";
import Colors from './colorStyle'

const componentStyle = {
  table: {
    fontSize: '1rem',
    borderCollapse: 'collapse',
    boxShadow: `0 0 15px rgba(0, 0, 0, 0.15);`,
    borderRadius: '0.5rem',
    "& thead tr": { 
      backgroundColor: Colors.infoColor,
      color: '#ffffff',
      textAlign: 'left',
      fontSize: '1.1rem'
    },
    "& td, & th": {
      padding: '0.3rem 1rem',
      whiteSpace: 'nowrap'
    },
    "& th": {
      fontWeight: 'bold',
      padding: '0.5rem 1rem'
    },
    "& tbody tr": {
      borderBottom: '1px solid #dddddd'
    },
    "& tbody tr:nth-of-type(even)": {
      backgroundColor: '#f3f3f3'
    },

    "& tbody tr:last-of-type": {
      // borderBottom: `2px solid ${Colors.infoColor}`
    },
    display: 'inline-block',
    overflow: 'auto',
  },
  table_container: {
    paddingTop: '1rem',
    background: 'white',
    width: isMobile ? '100%' : 'auto',
    overflow: 'auto'
  },
  link: {
    cursor: 'pointer',
    color: primaryColor,

    transition: 'all 0.4s',
    '&:hover': {
      backgroundColor: '#20222bf2',
      color: 'white'
    }
  }
};

export default componentStyle;